<template>
  <div>
    <template v-if="!editing">
      <div @dblclick="toEditing" class="name">{{ value }}</div>
    </template>
    <template v-else>
      <textarea
        id="editName"
        v-model="editingValue"
        @keypress.enter="applyName()"
        :disabled="disabled"
        class="textArea"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'AppEditableTextarea',
  props: {
    value: { type: String, default: '' },
    editing: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editingValue: null,
    }
  },
  created() {
    this.editingValue = this.value
  },
  methods: {
    toEditing() {
      this.$emit('edit')
    },
    applyName() {
      this.$emit('apply', { value: this.editingValue })
    },
  },
}
</script>

<style scoped>
.name {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  font-size: 14px;
}

.textArea {
  width: 100%;
  display: block;
  border: 1px solid skyblue;
}
</style>
